export default __webpack_public_path__ + "static/media/my-bg1.9f62b009.png";